import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  documentsAPI,
  CreateDocumentRequest,
  UpdateDocumentRequest,
} from "../api";

export const useGetDocuments = (search?: string) => {
  return useQuery({
    queryKey: ["documents", search],
    queryFn: () => documentsAPI.getAllDocuments(search),
  });
};

export const useGetDocumentById = (id: string) => {
  return useQuery({
    queryKey: ["document", id],
    queryFn: () => documentsAPI.getDocumentById(id),
    enabled: !!id,
  });
};

export const useCreateDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateDocumentRequest) =>
      documentsAPI.createDocument(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["documents"] });
    },
  });
};

export const useUpdateDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateDocumentRequest }) =>
      documentsAPI.updateDocument(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["documents"] });
    },
  });
};

export const useDeleteDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => documentsAPI.deleteDocument(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["documents"] });
    },
  });
};
